/*
 * @Description: 通用接口
 */
// import request from '@/utils/request';
import {request} from "@/api/request.js";

// 获取机构类型接口
export function selectMakertype(query) {
  return request({
    url: '/../vdict/wliss/maker/selectMakertype',
    method: 'get',
    params: query
  })
}
// 主机厂商下拉接口;传值makeTypeId：1主机厂商2终端供应商
export function getOrgSelectList(query) {
  return request({
    url: '/../vdict/wliss/maker/select',
    method: 'get',
    params: query
  })
}
// 获取品牌下拉接口
export function getMakerUseBrandSelectList(query) {
  return request({
    url: '/../vdict/wliss/brand/select',
    method: 'get',
    params: query
  })
}
// 获取车辆品类下拉接口
export function getMakerUseVehicleTypetSelectList(query) {
  return request({
    url: '/../vdict/wliss/makerUseVehicleType/select?makerId=10001',
    method: 'get',
    params: query
  })
}
// 获取型号下拉接口
export function getVehicleModelSelectList(query) {
  return request({
    url: '/../vdict/wliss/vehicleModel/select',
    method: 'get',
    params: query
  })
}
// 获取车辆三级分类下拉接口
export function getVehicleTypeSelectList(query) {
  return request({
    url: '/../vdict/wliss/vehicleType/braket',
    method: 'get',
    params: query
  })
}

// 通过条件查询车辆信息表多条数据
export function getVehicleSelectByModelList(query) {
  return request({
    url: "/../foundation/vehicle/select/list/by-model",
    method: "post",
    params: {
      _unpack: true,
    },
    data: query,
  });
}
// 获取车辆分档下拉接口
export function getVehicleBrakeSelectList(query) {
  return request({
    url: '/../vdict/wliss/vehicleType/selectBraketListBytypeCode',
    method: 'get',
    params: query
  })
}

// 通过机构代码/身份证号查询信息
export function getUserDeptInfo(data) {
  return request({
    url: '/system/user-dept/select/'+data.card,
    method: 'post',
    data: data
  })
}

// 公司品牌下拉接口
export function makerUseBrandSelectList (query) {
  return request({
    url: '/vdict/wliss/makerUseBrand/select',
    method: 'get',
    params: query
  })
}

// 通过合作社ID获取车辆列表
export function getCooperationVehicle(data) {
  return request({
    url: '/foundation/vehicle/select/list/by-cooperation',
    method: 'post',
    data: data
  })
}
